var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Sequencer from './Sequencer';
/**
 * A stubbed out version of {@link Sequencer} meant to be used by block
 * modes that use the MusicPlayer API. This allows us to migrate block modes
 * over to using the Sequencer model as we like, without completely crashing
 * if a block mode does not yet have a sequencer implementation.
 */
var MusicPlayerStubSequencer = /** @class */ (function (_super) {
    __extends(MusicPlayerStubSequencer, _super);
    function MusicPlayerStubSequencer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MusicPlayerStubSequencer.prototype.playSoundAtMeasureById = function () {
        console.log('Not implemented');
    };
    MusicPlayerStubSequencer.prototype.createTrack = function () {
        console.log('Not implemented');
    };
    MusicPlayerStubSequencer.prototype.addSoundsToTrack = function () {
        console.log('Not implemented');
    };
    MusicPlayerStubSequencer.prototype.addRestToTrack = function () {
        console.log('Not implemented');
    };
    MusicPlayerStubSequencer.prototype.getPlaybackEvents = function () {
        return [];
    };
    MusicPlayerStubSequencer.prototype.clear = function () {
        // no-op;
    };
    MusicPlayerStubSequencer.prototype.getLastMeasure = function () {
        return 0;
    };
    return MusicPlayerStubSequencer;
}(Sequencer));
export default MusicPlayerStubSequencer;
